export default __webpack_public_path__ + "static/purser-4b6a057ba6d18209e489391db133880c.mp4";